import { createIconInner } from '##/icons/Icon/createIconInner';

import props from './props';
import svg from './svg';

export const IconVolumeUp = createIconInner(props, svg);
